import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

const LEARN_MORE_URL =
  "https://help.freightsimple.com/using-freightsimple/booking-your-shipment/pickup-and-delivery-reference-numbers";

export interface ReferenceBubbleProps {
  heading: string;
  small: boolean | undefined;
}

// All four reference bubbles say the same thing about where the value ends up,
// and differ only in the question they lead with.
export function ReferenceBubble(props: ReferenceBubbleProps) {
  return (
    <Tooltip
      interactive
      variant="info"
      size={props.small ? "sm" : "default"}
      content={
        <Stack gap={2}>
          <T weight="bold">{props.heading}</T>
          <T size="xs" color="secondary">
            This information will be added to your generated documents.
          </T>
          <Link external href={LEARN_MORE_URL}>
            Learn more
          </Link>
        </Stack>
      }
    />
  );
}
